import { render, staticRenderFns } from "./SubmitFeedback.vue?vue&type=template&id=42ad0f3c&"
import script from "./SubmitFeedback.vue?vue&type=script&lang=js&"
export * from "./SubmitFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports